<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.addSponsor.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'common.requiredFieldsHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>{{ 'manageEvent.addSponsor.sponsorInfo' | translate }}</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="('manageEvent.addSponsor.sponsorName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.addSponsor.sponsorNamePlaceholder' | translate"
          [(value)]="sponsor_name"
          [invalid]="isSponsorNameInvalid"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'manageEvent.addSponsor.sponsorDescription' | translate"
          [type]="'text'"
          [placeholder]="'manageEvent.addSponsor.sponsorDescriptionPlaceholder' | translate"
          [(value)]="sponsor_description"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12">
        <h4>{{ 'manageEvent.addSponsor.logo' | translate }}</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="logoFile = $event[0]"
        />
      </div>

      <div class="col-lg-6 col-12">
        <h4>{{ 'manageEvent.addSponsor.bannerImage' | translate }}</h4>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="imageFile = $event[0]"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : ('manageEvent.addSponsor.saveSponsor' | translate)"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
